export enum CertificationLevels {
    ORDER = 'order',
    CHECKPOINT = 'checkpoint',
}
